export const projectDetails = {
    "iwmp_2014_2018": {
    "id": "iwmp_2014_2018",
        "name": "Integrated Watershed Management Program (IWMP)",
        "role": "Support Agency",
        "responsibility": "Under the scheme to increase the more efficient participation of women in the agriculture sector, women’s farmers groups have been formed in 25 villages of Kadegaon taluka to provide pre-season training to women in the group, new agriculture techniques, harvesting, processing of agricultural commodities, packaging, supply chain development, and marketing and sales arrangements, etc.",
        "agency": "Divisional of Agriculture joint director, Kolhapur Division.",
        "location": "Taluka Level, 25 villages of Kadegaon Talukas in Sangli district.",
        "duration": "2010 To 2011",
        "impact": "Increased women’s participation in agriculture, improved farming techniques, and better market access for agricultural products.",
        "image" :"/logo512.png"
},
    "sbm_rural_phase1_2015_2019": {
    "id": "sbm_rural_phase1_2015_2019",
        "name": "Swachh Bharat Mission (Rural) phase-1",
        "role": "Key Resource Centre (KRC)",
        "responsibility": "Under swachh bharat mission, the level of Hagandari-free Gram panchayat was verified according to two criteria.",
        "agency": "Maharashtra Government, drinking water and Sanitation department, Maharashtra",
        "location": "85 villages in Solapur District, 34 villages in Ratnagiri district, 58 villages Kolhapur district, 30 villages in Osmanabaad",
        "duration": "2015 To 2019",
        "impact": "Contributed to the sanitation improvements across multiple villages, leading to cleaner and healthier rural areas.",
        "image" :"/logo512.png"

    },
    "sbm_rural_phase2_2021_ongoing": {
    "id": "sbm_rural_phase2_2021_ongoing",
        "name": "Swachh Bharat Abhiyan (Rural) phase-2",
        "role": "Technical Service Provider (TSP)",
        "responsibility": "To conduct detailed project plan (DPR) of solid waste and sewage management project for survey work, preparation of estimates, supervision, and provision of technical advice/assistance.",
        "agency": "Zillha Parishad, Raigad",
        "location": "3 Villages in Roha Taluka",
        "duration": "2021 To Ongoing",
        "impact": "Helped establish sustainable waste management practices, improving sanitation and hygiene in rural communities.",
        "image" :"/logo512.png"

    }
}
